import { AppLink } from '@crm/components'
import { InvoiceForm } from '@crm/features/billing/components'
import { getRoute } from '@crm/utils'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'

const formName = 'create-invoice-form'

export const CreateInvoicePage = () => {
  const { t } = useLocales()

  return (
    <>
      <TitleSection title={t('billing.new_invoice')}>
        <AppLink to={getRoute('BillingInvoices')}>
          <Button>{t('buttons.cancel')}</Button>
        </AppLink>

        <Button type="primary" htmlType="submit" form={formName}>
          {t('buttons.save')}
        </Button>
      </TitleSection>

      <Flex justify="center">
        <InvoiceForm formName={formName} />
      </Flex>
    </>
  )
}
